module.exports = __webpack_public_path__ + "img/nat-turner.4aa66cc9.png";